import { FaLinkedin, FaXTwitter } from "react-icons/fa6";
import { motion } from "framer-motion";

const TeamCard = ({ name, title, description, isFounder = false, image, socials }) => {
  const socialIconVariants = {
    hidden: { opacity: 0, scale: 0.85, y: 10 },
    visible: (i) => ({
      opacity: 1,
      scale: 1,
      y: 0,
      transition: { delay: 0.2 + i * 0.1, type: "spring", stiffness: 300, damping: 20 },
    }),
    hover: {
      scale: 1.2,
      y: -2,
      color: "#9333ea",
      transition: { type: "spring", stiffness: 300 },
    },
  };

  return (
    <motion.div
      className={`relative bg-white rounded-3xl shadow-xl border border-white/60 p-6 transition-all overflow-hidden ${
        isFounder ? "max-w-[520px] min-h-[360px]" : "max-w-[340px] min-h-[360px]"
      } mx-auto flex flex-col justify-between`}
    >
      {/* Avatar + Main */}
      <div className="flex items-center gap-4">
        <div className="relative rounded-full p-1 bg-gradient-to-r from-primary to-secondary shadow-lg shrink-0">
          <img
            src={image}
            alt={name}
            className="w-24 h-24 rounded-full object-cover border-4 border-white shadow"
          />
        </div>
        <div className="flex-1">
          <h3 className="text-2xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent font-heading">
            {name}
          </h3>
          <p className="text-sm text-primary/80 font-medium mt-1">{title}</p>

          {/* Social Icons */}
          {socials && (
            <div className="flex gap-4 mt-3">
              {socials.linkedin && (
                <motion.a
                  href={socials.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:text-secondary"
                  variants={socialIconVariants}
                  initial="hidden"
                  animate="visible"
                  whileHover="hover"
                  custom={0}
                >
                  <FaLinkedin size={22} />
                </motion.a>
              )}
              {socials.twitter && (
                <motion.a
                  href={socials.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:text-secondary"
                  variants={socialIconVariants}
                  initial="hidden"
                  animate="visible"
                  whileHover="hover"
                  custom={1}
                >
                  <FaXTwitter size={22} />
                </motion.a>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Description always visible */}
      {description && (
        <motion.div
          className="mt-2 text-sm text-gray-700 leading-relaxed"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {description}
        </motion.div>
      )}

      {/* Founder badge */}
      {isFounder && (
        <div className="absolute top-4 right-4 bg-gradient-to-r from-primary to-secondary text-white text-xs font-semibold px-3 py-1 rounded-full shadow">
          Founder
        </div>
      )}
    </motion.div>
  );
};

export default TeamCard;
